import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/K1_Don't touch the automate.svg"

const K1Donttouchtheautomate: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 76 76'} component={Icon} {...props} fill="currentColor" />
export default K1Donttouchtheautomate
